import '.be{position:fixed;}.ssr-plugin'
import '.bf{inset:0px;}.ssr-plugin'
import '.cl{background:rgba(0,0,0,0.66);}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{align-items:center;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.cm{z-index:99;}.ssr-plugin'
import '.cn{animation-duration:1s;}.ssr-plugin'
import '.co{animation-effect:ease-in;}.ssr-plugin'
import '.a0{position:relative;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.b7{max-width:440px;}.ssr-plugin'
import '.bb{padding:32px;}.ssr-plugin'
import '.bl{gap:8px;}.ssr-plugin'
import '.cp{margin:24px;}.ssr-plugin'
import '.bg{overflow:hidden;}.ssr-plugin'
import '.br{text-align:center;}.ssr-plugin'
import { styled } from 'inlines'
import { SpinningLoader } from './SpinningLoader'
import { useTheme } from '../providers/useTheme'
import { Text } from './Text'
import { useEffect } from 'react'
import { useTranslations } from '../hooks/useTranslations'
import { capitalize } from '../utils/capitalize'

export const StripeProcessing = ({
  isWaiting,
  isProcessing,
}: {
  isWaiting?: boolean
  isProcessing?: boolean
}) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = ''
    }
  }, [])

  const { colors } = useTheme()
  const { data: dictionary } = useTranslations('checkout')

  return (
    <div className="be bf cl a b c cm"
    >
      <div className="cn co"
        style={{
          '@keyframes': {
            '0%': {
              opacity: 0,
            },
            '100%': {
              opacity: 1,
            },
          },}}
      />

      <div className="a0 h b7 bb b c bl cp bg br"
        style={{
          backgroundColor: colors.background,
          border: `1px solid ${colors.border}`,}}
      >
        <SpinningLoader size={64} style={{ margin: '0 auto' }} />
        <Text
          color="gradient"
          variant="title"
          isMultiline
          style={{ textAlign: 'center', marginBottom: 6, marginTop: 12 }}
        >
          {capitalize(dictionary?.processing_payment ?? '')}
        </Text>
        <Text style={{ textAlign: 'center' }}>
          {capitalize(
            isWaiting || isProcessing
              ? dictionary?.processing_payment_message
              : dictionary?.processing_payment_long_wait,
          )}
        </Text>
      </div>
    </div>
  )
}
